
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';

import { selectCurrentCampaign } from 'app/_state/campaign-context/campaign-context-selectors';
import { CampaignContextState } from 'app/_state/campaign-context/campaign-context-state';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { campaignSelectChangedAction } from './campaign-select-changed.action';
import { DefaultHomepage } from 'generated/graphql';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'app-campaign-switcher',
  templateUrl: './campaign-switcher.component.html',
})

export class CampaignSwitcherComponent extends WithDisposableSubject() implements OnInit {

  selectedCampaign = null;
  /**
   *
   */
  constructor(
    private cd: ChangeDetectorRef,
    private store: Store<CampaignContextState>,
    private router: Router) {
    super();
  }

  ngOnInit() {
    this.store.select(
      selectCurrentCampaign
    ).pipe(
      takeUntil(this.disposer)
    )
      .subscribe({
        next: campaign => {
          this.selectedCampaign = campaign;
          this.cd.markForCheck();
        },
        error: e => {
          console.error(e);
        }
      });
  }

  // TODO someday: have a service handle the routing for us... something like
  // /campaign-navigation.service.ts with a method like
  // navigateToDefaultPageForCampaign(campaignId: string)
  // or make it a guard on a specific route for example:
  // /campaign/:campaignId/home that redirects to the appropriate page based on campaign settings
  campaignSelected(input: { id: string; name: string, defaultHomepage: string }) {
    this.selectedCampaign = cloneDeep(input);

    this.store.dispatch(campaignSelectChangedAction({ campaignId: input?.id }));

    // Get which page to navigate to based on the campaign's default homepage setting
    if (input.defaultHomepage === DefaultHomepage.Overview) {
      this.router.navigate(['/dashboard'], { queryParams: { campaignId: input.id } });
      return;
    }

    this.router.navigate(['/entity/list'], { queryParams: { campaignId: input.id } });
  }
}
